/**
 * Throttling enforces a maximum number of times a function can be called over time
 * @param {Function} func Callback function
 * @param {Integer} limit Milliseconds
 * @returns {Function}
 */
export var throttle = function throttle(func, limit) {
  var lastCall = 0;
  return function () {
    var now = new Date().getTime();

    if (now - lastCall < limit) {
      return;
    }

    lastCall = now;
    return func.apply(void 0, arguments);
  };
};